export default __webpack_public_path__ + "static/media/GitIcon.187fb2ae.svg";